import { render, staticRenderFns } from "./fjpopup.vue?vue&type=template&id=3c765e5c&scoped=true&"
import script from "./fjpopup.vue?vue&type=script&lang=js&"
export * from "./fjpopup.vue?vue&type=script&lang=js&"
import style0 from "./fjpopup.vue?vue&type=style&index=0&id=3c765e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c765e5c",
  null
  
)

export default component.exports